import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
} from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ErrorDisplayComponent } from '@app/shared/components/error-display/error-display.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <h1 mat-dialog-title>Re-Send Event Link Email</h1>
        <mat-dialog-content>
            <div class="form">
                <div [formGroup]="form">
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" />
                        @if (ctrls['email'].invalid) {
                        <mat-error>
                            <shared-error-display [error]="ctrls['email'].errors"></shared-error-display>
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-raised-button color="primary" [disabled]="form.invalid" [mat-dialog-close]="form.value.email">
                Send Email
            </button>
        </mat-dialog-actions>
    `,
    styles: [
        `
            .form {
                padding-top: 8px;
            }
        `,
    ],
    imports: [
        // Angular Material components
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        MatDialogClose,
        MatFormField,
        MatInput,
        MatLabel,
        MatError,
        ReactiveFormsModule,

        ErrorDisplayComponent,
    ],
})
export class SendEventLinkEmailDialogComponent {
    readonly fb = inject(FormBuilder);
    readonly data = inject(MAT_DIALOG_DATA);

    get ctrls() {
        return this.form.controls;
    }

    form = this.fb.group({
        email: [this.data.email, [Validators.required, Validators.email]],
    });
}
